import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BhContentListItemComponent } from './bh-content-list-item.component';

@NgModule({
  declarations: [
    BhContentListItemComponent
    ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  exports: [
    BhContentListItemComponent
  ]
})
export class BhContentListItemComponentModule { }